// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'

// Selectors
import layers$ from './layers'
import { fieldOfSelectedJob$ } from 'hfty-assets'

export default createSelector(
  [
    layers$,
    fieldOfSelectedJob$,
  ],
  (layers, field) => {
    if (field) {
      const selectedLayers = _filter(layers, (layer) => {
        if (layer.asset === field.id) {
          return layer
        }
      })
      return selectedLayers
    }

    return null
  }
)
